/** 与 GET /api/credits/account 一致：仅认 remaining_credits，禁止用 total_credits 兜底（避免误显示 0） */
export function parseRemainingCreditsFromAccountResponse(data: {
  remaining_credits?: unknown;
}): number | null {
  const rc = data.remaining_credits;
  if (rc === undefined || rc === null || rc === '') return null;
  const n = Number(rc);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.floor(n);
}

/** @deprecated 使用 parseRemainingCreditsFromAccountResponse；成功解析前勿用于 UI */
export function remainingCreditsFromAccountResponse(data: {
  remaining_credits?: unknown;
  total_credits?: unknown;
}): number {
  return parseRemainingCreditsFromAccountResponse(data) ?? 0;
}

/** 成功响应才应更新 lastKnownGood：须能解析 remaining_credits，且非「无 public 用户却显示 0」 */
export function isCreditsAccountResponseTrustworthy(data: {
  public_user_id?: string | null;
  remaining_credits?: unknown;
}): boolean {
  const remaining = parseRemainingCreditsFromAccountResponse(data);
  if (remaining === null) return false;
  const hasPublic = Boolean(data.public_user_id && String(data.public_user_id).trim());
  if (!hasPublic && remaining === 0) return false;
  return true;
}
